import React from "react"
import { processMarkdown } from "@/controllers/markdown";

interface MarkdownProps {
    content: string;
    allowHTML?: boolean | undefined;
}

const Markdown: React.FC<MarkdownProps> = ({ content, allowHTML = false }) => (
    <div
        className="markdown"
        dangerouslySetInnerHTML={{
            __html: processMarkdown(content, allowHTML ?? false),
        }}
    ></div>
);

export default Markdown;